import React, { Component } from 'react'
import { Row, Col, Container } from 'react-bootstrap';

// Components
import Header from '../../components/Dashboard/Header'
import MultiTab from '../../components/Dashboard/MultiTab'
import ImagePanel from '../../components/Dashboard/ImagePanel'
import firebase from '../../firestore'
import Loading from '../../components/Loading'

class Dashboard extends Component {

    state = { userDetails: undefined }
    componentDidMount() {
        this.firebaseref = firebase.database().ref("/users/")
        this.firebaseref.orderByChild("email")
            .equalTo(firebase.auth().currentUser.email)
            .once("value", (snapshot) => {
                if (snapshot.val() !== null) {
                    const username = Object.keys(snapshot.val())[0];
                    this.firebaserefUser = firebase.database().ref("/users/" + username)
                    this.firebaserefUser.on("value", (snapshotC) => {
                        this.setState({ userDetails: snapshotC.val() })
                        console.log('value changed')
                    });
                }
            });
    }

    componentWillUnmount() {
        if (this.firebaserefUser) {
            this.firebaserefUser.off()
        }
    }

    render() {
        if (!this.state.userDetails) {
            return <Loading />
        }
        return (
            <Container fluid className="container_Dashboard">
                <Row>
                    <Col lg={7} sm={12} xs={12} className="leftPanel">
                        <Header userDetails={this.state.userDetails} />
                        <MultiTab userDetails={this.state.userDetails} />

                    </Col>
                    <Col lg={5} sm={12} xs={12}>
                        <ImagePanel userDetails={this.state.userDetails} />
                    </Col>

                </Row>
            </Container>
        )
    }
}

export default Dashboard;
